import React, { useState, useEffect } from "react";
import "./Invoice.css";
import axios from "axios";
import DataTable_Component from "../../components/invoice/Data Table/index";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Add_data_modal from "../../components/invoice/update_data_modal";
import InvoiceDetailModal from "../../components/invoice/Invoice Details";
import Layouts from "../../layouts/layouts";
import * as XLSX from "xlsx";
import {
  faEye,
  faPenToSquare,
  faTrash,
  faEnvelope,
  faFileExcel,
  faFileInvoice,
  faChartLine,
  faRotateLeft,
  faPlus,
  faFilePdf,
} from "@fortawesome/free-solid-svg-icons";
import Switch from "react-switch";

/* ------------------------------------------------------------------ */
/* Constants & helpers                                                 */
/* ------------------------------------------------------------------ */

const ACCENT = "#0f766e";
const IST = "Asia/Kolkata";

const switchProps = {
  onColor: ACCENT,
  offColor: "#cbd5e1",
  height: 20,
  width: 38,
  handleDiameter: 16,
  uncheckedIcon: false,
  checkedIcon: false,
};

const MONTHS = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];

const EMPTY_SUMMARY = {
  totalPayout: 0,
  totalInvoiceGenerated: 0,
  totalPaymentReceived: 0,
  totalDataCount: 0,
  invoiceGeneratedCount: 0,
  paymentReceivedCount: 0,
  invoicePendingCount: 0,
  paymentPendingCount: 0,
};

const inr = (n) =>
  Number(n || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

/* Returns { date: "12 Mar 2026", time: "04:35 PM IST" | null } */
const formatDateTimeIST = (value) => {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return { date: String(value), time: null };

  const date = d.toLocaleDateString("en-IN", {
    timeZone: IST,
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  // Old records only have a date (saved as YYYY-MM-DD / midnight UTC),
  // so don't show a fake 05:30 AM time for them.
  const isDateOnly =
    /^\d{4}-\d{2}-\d{2}$/.test(String(value)) ||
    (d.getUTCHours() === 0 &&
      d.getUTCMinutes() === 0 &&
      d.getUTCSeconds() === 0 &&
      d.getUTCMilliseconds() === 0);

  if (isDateOnly) return { date, time: null };

  const time = d
    .toLocaleTimeString("en-IN", {
      timeZone: IST,
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
    .toUpperCase();

  return { date, time: `${time}` };
};

/* Selected date + current IST time -> ISO timestamp */
const buildISTTimestamp = (dateStr) => {
  const nowTime = new Date().toLocaleTimeString("en-GB", {
    timeZone: IST,
    hour12: false,
  }); // "HH:MM:SS"
  return new Date(`${dateStr}T${nowTime}+05:30`).toISOString();
};

/* Switch + timeline shown underneath */
const SwitchWithTimeline = ({ checked, disabled, onChange, dateValue }) => {
  const dt = checked ? formatDateTimeIST(dateValue) : null;
  return (
    <div className="inv-toggle-cell">
      <Switch
        onChange={onChange}
        checked={!!checked}
        disabled={disabled}
        {...switchProps}
      />
      <div className={`inv-timeline${dt ? " inv-timeline--done" : ""}`}>
        <span className="inv-timeline__dot" />
        {dt ? (
          <span className="inv-timeline__text">
            <span className="inv-timeline__date">{dt.date}</span>
            {dt.time && <span className="inv-timeline__time">{dt.time}</span>}
          </span>
        ) : (
          <span className="inv-timeline__text inv-timeline__text--pending">
            Pending
          </span>
        )}
      </div>
    </div>
  );
};

const percent = (part, whole) =>
  whole > 0 ? Math.min(100, Math.round((Number(part) / Number(whole)) * 100)) : 0;

const monthShort = (m) =>
  MONTHS[Number(m) - 1]?.label.slice(0, 3) || String(m).padStart(2, "0");

/* Numeric selector (sorts correctly) + formatted cell (reads nicely) */
const moneyColumn = (name, key) => ({
  name: <b>{name}</b>,
  selector: (row) => {
    const v = parseFloat(row[key]);
    return isNaN(v) ? 0 : v;
  },
  cell: (row) => {
    const v = parseFloat(row[key]);
    return <span className="inv-money">{isNaN(v) ? "-" : inr(v)}</span>;
  },
  sortable: true,
  right: true,
});

export default function Invoice() {
  const title = "Invoice Details";

  const [apistate, setApiState] = useState([]);
  const [selectVal] = useState([]);
  const [openModal] = useState(true);
  const [lockedSwitches, setLockedSwitches] = useState({
    misEmailSent: new Set(),
    paymentReceived: new Set(),
  });

  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [update_modal_data, setUpdate_modal_data] = useState("");

  const [customMonth, setCustomMonth] = useState("");
  const [customYear, setCustomYear] = useState("");
  const [showGenerateBtn, setShowGenerateBtn] = useState(false);
  const [invoiceSummary, setInvoiceSummary] = useState(EMPTY_SUMMARY);

  const [currentPage, setCurrentPage] = useState(1);
  const [showInvoiceDetailModal, setShowInvoiceDetailModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [limit, setLimit] = useState(5);
  const [search, setSearch] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [isFiltered, setIsFiltered] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [exporting, setExporting] = useState(false);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

  /* ---------------------------------------------------------------- */
  /* Table columns                                                     */
  /* ---------------------------------------------------------------- */

  const columns = [
    {
      name: <b>Client</b>,
      selector: (row) => (row.id_client ? row.id_client?.name : "N/A"),
      cell: (row) => (
        <span className="inv-client">
          {row.id_client ? row.id_client?.name : "N/A"}
        </span>
      ),
      sortable: true,
      grow: 2,
    },
    {
      name: <b>Period</b>,
      selector: (row) => `${row.year} / ${String(row.month).padStart(2, "0")}`,
      cell: (row) => (
        <span className="inv-period">
          {monthShort(row.month)} {row.year}
        </span>
      ),
      sortable: true,
    },
    moneyColumn("Payout (₹)", "payout"),
    moneyColumn("Invoiced (₹)", "invoiceGenerated"),
    moneyColumn("Received (₹)", "actualAmountReceived"),
    {
      name: <b>UTR Number</b>,
      selector: (row) => row.utrNumber || row.utr || row.UTR || "",
      cell: (row) => (
        <span className="inv-period">
          {row.utrNumber || row.utr || row.UTR || "-"}
        </span>
      ),
      sortable: true,
      grow: 1.5,
    },
    {
      name: <b>MIS mail sent</b>,
      selector: (row) => (row.misEmailSent ? "True" : "False"),
      cell: (row) => (
        <SwitchWithTimeline
          checked={row.misEmailSent}
          dateValue={row.misEmailSentDate}
          onChange={() => handleToggleSwitch(row, "misEmailSent")}
          disabled={
            lockedSwitches.misEmailSent.has(row._id) || row.misEmailSent
          }
        />
      ),
      sortable: true,
      center: true,
      grow: 1.3,
    },
    {
      name: <b>Payment received</b>,
      selector: (row) => (row.paymentReceived ? "True" : "False"),
      cell: (row) => (
        <SwitchWithTimeline
          checked={row.paymentReceived}
          dateValue={row.paymentReceivedDate}
          onChange={() => handleToggleSwitch(row, "paymentReceived")}
          disabled={
            lockedSwitches.paymentReceived.has(row._id) || row.paymentReceived
          }
        />
      ),
      sortable: true,
      center: true,
      grow: 1.3,
    },
    {
      name: <b>Actions</b>,
      cell: (row) => (
        <div className="inv-row-actions">
          <button
            type="button"
            onClick={() => viewInvoice(row)}
            className="inv-icon-btn inv-icon-btn--view"
            title="View details"
            aria-label="View invoice details"
          >
            <FontAwesomeIcon icon={faEye} />
          </button>

          {row.invoicePdfUrl && (
            <a
              href={row.invoicePdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inv-icon-btn inv-icon-btn--pdf"
              title="View invoice PDF"
              aria-label="View invoice PDF"
            >
              <FontAwesomeIcon icon={faFilePdf} />
            </a>
          )}

          <button
            type="button"
            onClick={() => setUpdateStoreBtn(row)}
            className="inv-icon-btn inv-icon-btn--edit"
            title="Edit invoice"
            aria-label="Edit invoice"
          >
            <FontAwesomeIcon icon={faPenToSquare} />
          </button>

          <button
            type="button"
            onClick={() => delete_row(row)}
            className="inv-icon-btn inv-icon-btn--delete"
            title="Delete invoice"
            aria-label="Delete invoice"
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </div>
      ),
    },
  ];

  /* ---------------------------------------------------------------- */
  /* Data fetching                                                     */
  /* ---------------------------------------------------------------- */

  const updateInvoice = (updated) => {
    setApiState((prev) =>
      prev.map((invoice) => (invoice._id === updated._id ? updated : invoice)),
    );
  };

  const handleFetchCustomData = async (page = 1) => {
    if (!customMonth || !customYear) {
      Swal.fire(
        "Select month and year",
        "Please select both a month and a year.",
        "warning",
      );
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      Swal.fire("Error", "No token found. Please log in again.", "error");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v4/invoices/get-all`,
        {
          params: {
            month: customMonth,
            year: customYear,
            page,
            limit,
            search: search.trim(),
          },
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const invoices = response.data?.invoices || [];
      setApiState(invoices);
      setTotalCount(response.data?.count || 0);
      setInvoiceSummary({ ...EMPTY_SUMMARY, ...response.data?.summary });
      setCurrentPage(page);
      setIsFiltered(true);
      setHasFetched(true);

      // Only offer "generate" when the month is empty, not when a search has no match
      const monthIsEmpty = invoices.length === 0 && !search.trim();
      setShowGenerateBtn(monthIsEmpty);
    } catch (error) {
      console.error("Fetch invoices error:", error);
      setApiState([]);
      setTotalCount(0);
      setHasFetched(true);
      Swal.fire(
        "Error",
        error.response?.data?.message || "Unable to fetch invoices.",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleGenerateInvoice = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      Swal.fire("Error", "No token found", "error");
      return;
    }

    setGenerating(true);
    try {
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v4/invoices/sync`, {
        params: { month: customMonth, year: customYear },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      Swal.fire("Success", "Invoices generated successfully", "success");
      await handleFetchCustomData(1);
    } catch (error) {
      console.error("Generation Error:", error);
      Swal.fire("Error", "Invoice generation failed", "error");
    } finally {
      setGenerating(false);
    }
  };

  const fetchData = async (page) => {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found");
      return;
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const base = `${process.env.REACT_APP_BASE_URL}/api/v4/invoices/get-all`;

    // Previous month and year
    const prev = new Date();
    prev.setMonth(prev.getMonth() - 1);
    const prevMonth = prev.getMonth() + 1;
    const prevYear = prev.getFullYear();

    const apply = (data) => {
      setApiState(data.invoices || []);
      setTotalCount(data.count || 0);
      setInvoiceSummary(data.summary || EMPTY_SUMMARY);
    };

    setLoading(true);
    try {
      const prevResponse = await axios.get(
        `${base}?month=${prevMonth}&year=${prevYear}&page=${page}&limit=${limit}&search=${search}`,
        { headers },
      );

      if (
        Array.isArray(prevResponse.data.invoices) &&
        prevResponse.data.invoices.length > 0
      ) {
        apply(prevResponse.data);
        return;
      }

      // Fall back to the latest month that has data
      const allResponse = await axios.get(base, { headers });
      const allInvoices = allResponse.data.invoices || [];
      if (allInvoices.length === 0) {
        setApiState([]);
        return;
      }

      const latest = [...allInvoices].sort(
        (a, b) =>
          new Date(b.year, b.month - 1) - new Date(a.year, a.month - 1),
      )[0];

      const latestResponse = await axios.get(
        `${base}?month=${latest.month}&year=${latest.year}&page=${page}&limit=${limit}&search=${search}`,
        { headers },
      );
      apply(latestResponse.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const refreshList = () => {
    if (isFiltered && customMonth && customYear) {
      handleFetchCustomData(currentPage);
    } else {
      fetchData(currentPage);
    }
  };

  // Apply the month/year filter as soon as both are selected.
  useEffect(() => {
    if (!customMonth || !customYear) return;
    setCurrentPage(1);
    setIsFiltered(true);
    handleFetchCustomData(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customMonth, customYear]);

  // Keep the selected month/year when searching or paginating.
  useEffect(() => {
    refreshList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, limit, search]);

  const resetFilters = () => {
    setCustomMonth("");
    setCustomYear("");
    setSearch("");
    setCurrentPage(1);
    setIsFiltered(false);
    setShowGenerateBtn(false);
    setHasFetched(false);
    fetchData(1);
  };

  /* ---------------------------------------------------------------- */
  /* Row actions                                                       */
  /* ---------------------------------------------------------------- */

  const handleToggleSwitch = async (invoice, field) => {
    const fieldDateMap = {
      misEmailSent: "misEmailSentDate",
      paymentReceived: "paymentReceivedDate",
    };
    const friendlyLabel = {
      misEmailSent: "Mail sent",
      paymentReceived: "Payment received",
    };

    if (invoice[field]) return; // cannot switch off once set

    const today = new Date().toISOString().split("T")[0];

    const { value: inputDate } = await Swal.fire({
      title: `<div style="font-size:21px;font-weight:700;color:${ACCENT};">
                ${friendlyLabel[field]}
              </div>`,
      html: `
        <div style="margin-top:12px;font-size:15px;color:#475569;">
          Select the date for <strong>${friendlyLabel[field]}</strong>
        </div>
        <input type="date" id="date-input" class="swal2-input"
          style="margin-top:12px;font-size:15px;padding:8px;" max="${today}" />
      `,
      showCancelButton: true,
      confirmButtonText: "Save date",
      cancelButtonText: "Cancel",
      confirmButtonColor: ACCENT,
      focusConfirm: false,
      preConfirm: () => {
        const dateVal = document.getElementById("date-input").value;
        if (!dateVal) Swal.showValidationMessage("Please select a valid date.");
        return dateVal;
      },
    });

    if (!inputDate) return;

    try {
      const token = localStorage.getItem("token");
      if (!token) return console.error("No token");

      // Selected date + current IST time
      const payload = {
        [field]: true,
        [fieldDateMap[field]]: buildISTTimestamp(inputDate),
      };

      await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/v4/invoices/update/${invoice._id}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setApiState((prev) =>
        prev.map((item) =>
          item._id === invoice._id ? { ...item, ...payload } : item,
        ),
      );

      setLockedSwitches((prev) => {
        const updated = new Set(prev[field]);
        updated.add(invoice._id);
        return { ...prev, [field]: updated };
      });

      Swal.fire({
        icon: "success",
        title: "Saved",
        text: `${friendlyLabel[field]} status and date updated.`,
        confirmButtonColor: ACCENT,
      });
    } catch (error) {
      Swal.fire("Error", `Failed to update ${friendlyLabel[field]}.`, "error");
      console.error(`Update error for ${field}:`, error);
    }
  };

  const setUpdateStoreBtn = (row) => {
    setOpen_update_modal({
      render: !open_update_modal.render,
      modal_open: true,
    });
    setUpdate_modal_data(row);
  };

  const viewInvoice = (invoice) => {
    setSelectedInvoice(invoice);
    setShowInvoiceDetailModal(true);
  };

  const delete_row = (row) => {
    Swal.fire({
      icon: "warning",
      title: "Delete this invoice?",
      text: "This can't be undone.",
      showCancelButton: true,
      confirmButtonText: "Delete",
      confirmButtonColor: "#dc2626",
    }).then((result) => {
      if (!result.isConfirmed) return;

      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }
      axios
        .delete(
          `${process.env.REACT_APP_BASE_URL}/api/v4/invoices/delete/${row._id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        )
        .then(() => {
          Swal.fire("Deleted", "The invoice has been deleted.", "success");
          refreshList();
        })
        .catch((error) => {
          Swal.fire("Error", "The invoice could not be deleted.", "error");
          console.error("Error deleting data:", error);
        });
    });
  };

  /* ---------------------------------------------------------------- */
  /* Export & email                                                    */
  /* ---------------------------------------------------------------- */

  const exportToExcel = async () => {
    setExporting(true);
    try {
      const token = localStorage.getItem("token");

      // No pagination params: export everything that matches the filters
      const params = {};
      if (search) params.search = search;
      if (customMonth) params.month = customMonth;
      if (customYear) params.year = customYear;

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v4/invoices/get-all`,
        { params, headers: { Authorization: `Bearer ${token}` } },
      );

      const istText = (value) => {
        const d = formatDateTimeIST(value);
        return d ? `${d.date}${d.time ? ", " + d.time : ""}` : "-";
      };

      const rows = (response.data.invoices || []).map((invoice) => ({
        "Client Name": invoice.id_client?.name || "No Client",
        Year: invoice.year,
        Month: invoice.month,
        Trips: invoice.trips,
        "Total Km": invoice.totalKm,
        Payout: invoice.payout,
        "Cash Short": invoice.cashSort,
        "Fixed Vehicle Count": invoice.fixedVehicleCount,
        "MIS Email Sent": invoice.misEmailSent ? "Yes" : "No",
        "MIS Email Sent Date": istText(invoice.misEmailSentDate),
        "Actual Amount Received": invoice.actualAmountReceived || "-",
        "UTR Number": invoice.utrNumber || invoice.utr || invoice.UTR || "-",
        "Payment Received": invoice.paymentReceived ? "Yes" : "No",
        "Payment Received Date": istText(invoice.paymentReceivedDate),
        Comments: invoice.comments || "-",
      }));

      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Invoices");
      XLSX.writeFile(workbook, "InvoicesData.xlsx");
    } catch (error) {
      console.error("Export error:", error);
      Swal.fire("Error", "Unable to export invoices.", "error");
    } finally {
      setExporting(false);
    }
  };

  const sendInvoiceEmail = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        Swal.fire("Error", "No token found", "error");
        return;
      }

      const displayedMonth = customMonth || apistate?.[0]?.month;
      const displayedYear = customYear || apistate?.[0]?.year;

      if (!displayedMonth || !displayedYear) {
        Swal.fire(
          "No data",
          "There is no invoice data available to send.",
          "warning",
        );
        return;
      }

      const monthNumber = Number(displayedMonth);
      const yearNumber = Number(displayedYear);
      const monthName = new Date(yearNumber, monthNumber - 1).toLocaleString(
        "en-IN",
        { month: "long" },
      );

      const confirmResult = await Swal.fire({
        title: "Send invoice email?",
        html: `
          <p style="margin-bottom:10px;">
            The email will contain invoice and payment details for:
          </p>
          <h4 style="color:${ACCENT};margin-bottom:20px;">
            ${monthName} ${yearNumber}
          </h4>
          <div style="text-align:left;">
            <label for="email-note"
              style="font-weight:600;font-size:14px;color:#334155;display:block;margin-bottom:8px;">
              Add a note (optional)
            </label>
            <textarea id="email-note" class="swal2-textarea"
              placeholder="Enter any additional message or instruction..."
              style="width:90%;min-height:120px;resize:vertical;font-size:14px;"></textarea>
          </div>
        `,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Send email",
        cancelButtonText: "Cancel",
        confirmButtonColor: ACCENT,
        focusConfirm: false,
        preConfirm: () => ({
          note: document.getElementById("email-note")?.value?.trim() || "",
        }),
      });

      if (!confirmResult.isConfirmed) return;

      Swal.fire({
        title: "Sending email...",
        text: `Preparing invoice data for ${monthName} ${yearNumber}`,
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v4/invoices/send-email`,
        {
          params: {
            month: monthNumber,
            year: yearNumber,
            additionalNote: confirmResult.value?.note || "",
          },
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      Swal.fire({
        title: "Email sent",
        html: `Invoice and payment summary for <strong>${monthName} ${yearNumber}</strong> has been sent.`,
        icon: "success",
        confirmButtonColor: ACCENT,
      });
    } catch (error) {
      console.error("Send Invoice Email Error:", error);
      Swal.fire({
        title: "Email failed",
        text: error?.response?.data?.message || "Unable to send invoice email.",
        icon: "error",
      });
    }
  };

  /* ---------------------------------------------------------------- */
  /* Derived view data                                                 */
  /* ---------------------------------------------------------------- */

  const periodLabel =
    customMonth && customYear
      ? `${MONTHS[Number(customMonth) - 1]?.label} ${customYear}`
      : apistate[0]
        ? `${MONTHS[Number(apistate[0].month) - 1]?.label} ${apistate[0].year}`
        : "";

  const s = invoiceSummary;
  const invoicedPct = percent(s.totalInvoiceGenerated, s.totalPayout);
  const receivedPct = percent(s.totalPaymentReceived, s.totalInvoiceGenerated);

  const kpis = [
    {
      label: "Total payout",
      value: `₹ ${inr(s.totalPayout)}`,
      tone: "blue",
      money: true,
    },
    {
      label: "Invoiced",
      value: `₹ ${inr(s.totalInvoiceGenerated)}`,
      tone: "green",
      money: true,
      progress: invoicedPct,
      hint: `${invoicedPct}% of payout invoiced`,
    },
    {
      label: "Received",
      value: `₹ ${inr(s.totalPaymentReceived)}`,
      tone: "violet",
      money: true,
      progress: receivedPct,
      hint: `${receivedPct}% of invoiced amount received`,
    },
    { label: "Invoices", value: s.totalDataCount || 0, tone: "slate" },
    { label: "Generated", value: s.invoiceGeneratedCount || 0, tone: "green" },
    { label: "Paid", value: s.paymentReceivedCount || 0, tone: "violet" },
    { label: "Payment pending", value: s.paymentPendingCount || 0, tone: "red" },
  ];

  const hasActiveFilter = !!(customMonth || customYear || search);

  /* ---------------------------------------------------------------- */
  /* Render                                                            */
  /* ---------------------------------------------------------------- */

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />
      <Add_data_modal
        select_data={update_modal_data}
        open_update_data_modal={open_update_modal}
        onUpdateInvoice={updateInvoice}
      />
      <InvoiceDetailModal
        show={showInvoiceDetailModal}
        onHide={() => setShowInvoiceDetailModal(false)}
        invoice={selectedInvoice}
      />

      <main className="container-fluid inv-page">
        {/* Page header */}
        <header className="inv-header">
          <div className="inv-header__lead">
            <div>
              <h1 className="inv-title">{title}</h1>
              <p className="inv-subtitle">
                {periodLabel ? `Showing ${periodLabel}` : "Latest available month"}
              </p>
            </div>
          </div>

          <div className="inv-actions">
            <Link to="/mis" className="inv-btn inv-btn--ghost">
              <FontAwesomeIcon icon={faChartLine} />
              MIS
            </Link>
            <button
              type="button"
              onClick={exportToExcel}
              className="inv-btn inv-btn--ghost"
              disabled={exporting}
            >
              <FontAwesomeIcon icon={faFileExcel} />
              {exporting ? "Exporting..." : "Export"}
            </button>
            <button
              type="button"
              onClick={sendInvoiceEmail}
              className="inv-btn inv-btn--primary"
              disabled={!apistate || apistate.length === 0}
            >
              <FontAwesomeIcon icon={faEnvelope} />
              Send email
            </button>
          </div>
        </header>

        {/* Compact KPI strip */}
        <section className="inv-kpis" aria-label="Invoice summary">
          {kpis.map((k) => (
            <div
              key={k.label}
              className={`inv-kpi inv-kpi--${k.tone}${k.money ? " inv-kpi--money" : ""}`}
              title={k.hint || undefined}
            >
              <span className="inv-kpi__label">{k.label}</span>
              <strong className="inv-kpi__value">{k.value}</strong>
              {typeof k.progress === "number" && (
                <span
                  className="inv-kpi__bar"
                  role="progressbar"
                  aria-valuenow={k.progress}
                  aria-valuemin={0}
                  aria-valuemax={100}
                  aria-label={k.hint}
                >
                  <i style={{ width: `${k.progress}%` }} />
                </span>
              )}
            </div>
          ))}
        </section>

        {/* Table panel */}
        <section className="inv-panel">
          <div className="inv-toolbar">
            <div className="inv-filters">
              <select
                className="inv-select"
                aria-label="Month"
                value={customMonth}
                onChange={(e) => setCustomMonth(e.target.value)}
              >
                <option value="">All months</option>
                {MONTHS.map((m) => (
                  <option key={m.value} value={m.value}>
                    {m.label}
                  </option>
                ))}
              </select>

              <select
                className="inv-select"
                aria-label="Year"
                value={customYear}
                onChange={(e) => setCustomYear(e.target.value)}
              >
                <option value="">All years</option>
                {years.map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select>

              {hasActiveFilter && (
                <button
                  type="button"
                  className="inv-btn inv-btn--text"
                  onClick={resetFilters}
                >
                  <FontAwesomeIcon icon={faRotateLeft} />
                  Reset
                </button>
              )}
            </div>

            <div className="inv-toolbar__end" role="status" aria-live="polite">
              {loading ? (
                <span className="inv-inline-loading">
                  <span className="inv-spinner" aria-hidden="true" />
                  Loading
                </span>
              ) : (
                <span className="inv-count">
                  {totalCount} {totalCount === 1 ? "invoice" : "invoices"}
                </span>
              )}
            </div>
          </div>

          <div className="inv-table-wrap">
            {loading && apistate.length === 0 ? (
              <div className="inv-skeleton" aria-hidden="true">
                {Array.from({ length: 5 }).map((_, i) => (
                  <span key={i} className="inv-skeleton__row" />
                ))}
              </div>
            ) : apistate.length > 0 ? (
              <div className={loading ? "inv-table-fade" : undefined}>
                <DataTable_Component
                  searchBy="Client"
                  title_btn={true}
                  apidata={apistate}
                  columns={columns}
                  totalRecords={totalCount}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  rowsPerPage={limit}
                  setRowsPerPage={setLimit}
                  search={search}
                  setSearch={setSearch}
                />
              </div>
            ) : (
              <div className="inv-empty">
                <span className="inv-empty__icon" aria-hidden="true">
                  <FontAwesomeIcon icon={faFileInvoice} />
                </span>
                <h2 className="inv-empty__title">
                  {hasFetched ? "No invoices found" : "No invoices yet"}
                </h2>
                <p className="inv-empty__text">
                  {showGenerateBtn
                    ? `There are no invoices for ${periodLabel}. You can generate them now.`
                    : hasFetched
                      ? "Nothing matches these filters. Try another month, year or search term."
                      : "Invoices will appear here once they are available."}
                </p>
                {showGenerateBtn && (
                  <button
                    type="button"
                    className="inv-btn inv-btn--primary"
                    onClick={handleGenerateInvoice}
                    disabled={generating}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                    {generating ? "Generating..." : `Generate invoices`}
                  </button>
                )}
              </div>
            )}
          </div>
        </section>
      </main>
    </>
  );
}